/**
 * @desc Snowmaking layers to import into the store
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

import signage from "./signage";
import banners from "./banners";
import infoboard from "./infoboard";
import other from "./other";
import summersigns from "./summersigns";
import trailsigns from "./trailsigns";

import baseareaoperations from "./baseareaoperations";
import foodandbeverage from "./foodandbeverage";
import it from "./it";
import legal from "./legal";
import maintenanceandoperations from "./maintenanceandoperations";
import productsalesandservice from "./productsalesandservice";
import retailrental from "./retailrental";
import snowschool from "./snowschool";
import marketingandsales from "./marketingandsales";

export default {
  modules: {
    signage,
    infoboard,
    banners,
    trailsigns,
    summersigns,
    other,
    legal,
    maintenanceandoperations,
    productsalesandservice,
    it,
    foodandbeverage,
    marketingandsales,
    retailrental,
    snowschool,
    baseareaoperations
  }
};
